/* import __COLOCATED_TEMPLATE__ from './edit-page-layout-instructions.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';

export interface Args {}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

const SalesforceCopilotEditPageLayoutInstructions = templateOnlyComponent<Signature>();
export default SalesforceCopilotEditPageLayoutInstructions;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Copilot::EditPageLayoutInstructions': typeof SalesforceCopilotEditPageLayoutInstructions;
  }
}
